import {Modal} from '../index';
import {useDispatch} from 'react-redux';
import {} from '../../../../reducers/modules/actions';
import {navigate} from '../../../../utils/navigation';

import Info from './info';
import Share from './share';
import Verify from './verify';

export default ({modal, data}) => {
    const dispatch = useDispatch();

    return (
        <Modal>
            {data.stage === "info" && <Info data={data.info} />}
            {data.stage === "share" && <Share data={data.share} />}
            {data.stage === "verify" && <Verify data={data.verify} />}
        </Modal>
    )
} 